function ctrl($scope, Global, timeFormat, fetchStream, $stateParams, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.lineChartIdentifiers = { key: false, id: false };
    model.rowChartIdentifiers = { key: false, id: false };
    model.geoChartIdentifiers = { key: false, id: false };
    model.sevLevIdentifiers = { key: false, id: false };
    model.tableIdentifiers =
        { key: false, id: false };

    socketIo('/api/hybrid_alerts/nta_details').then(function (socket) {

        /////////////
        /// TABLE ///
        /////////////
        // register data object
        $scope.main.registerVisual({
            // allSearchDimensionOverride: true, // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            refresh: true, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'table',
                socket: socket
            },
            grouping: ['id'],
            sort: { direction: "-orig", col: "time" }, // "-"=desc, "+"=asc
            title: 'NTA Details',
            columns: [
                { title: 'Date', select: 'time', dView: true },
                { title: 'Source', select: 'orig', dView: true },
                { title: 'Destination', select: 'resp', dView: true },
                { title: 'File UID', select: 'fuid', dView: false },
                { title: 'File MIME Type', select: 'file_mime_type', dView: false },
                { title: 'File description', select: 'file_desc', dView: false },
                { title: 'Protocol', select: 'proto', dView: true },
                { title: 'Note', select: 'note', dView: true },
                { title: 'Message', select: 'msg', dView: false },
                { title: 'sub', select: 'sub', dView: false },
                { title: 'src', select: 'src', dView: false },
                { title: 'dst', select: 'dst', dView: false },
                { title: 'p', select: 'p', dView: false },
                { title: 'n', select: 'n', dView: false },
                { title: 'peer_descr', select: 'peer_descr', dView: true },
                { title: 'Actions', select: 'actions', dView: true },
                { title: 'suppress_for', select: 'suppress_for', dView: false },
                { title: 'remote_location_country_code', select: 'remote_location_country_code', dView: false },
                { title: 'remote_location_region', select: 'remote_location_region', dView: false },
                { title: 'remote_location_city', select: 'remote_location_city', dView: false },
                { title: 'remote_location_latitude', select: 'remote_location_latitude', dView: false },
                { title: 'remote_location_longitude', select: 'remote_location_longitude', dView: false },
            ],
            searchCategories: {
            }
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);
            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // return promise to build dimensions and groups for table
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        })
        .then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        }, function (err) {
            console.log('table error', err);

        }, function (result) {
            console.log('table result', result.rows)
            // add rows
            console.log($scope.main.dataObjects[model.tableIdentifiers.key])
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                // with our first data return, we can build dimensions and groups for our data
                $scope.main.buildDimGroup(result.rows, model.tableIdentifiers).then(function () {
                    // dont start the spinner if the table loads faster than building group dim
                    if (!model.complete) {
                        // start table spinner right before init, but after build
                        usSpinnerService.spin(model.tableIdentifiers.id);
                    }
                    // initalize rows
                    $scope.$broadcast('init', model.tableIdentifiers);
                    if (result.min) {
                        model.loadStart = result.min;
                    }
                }, function (err) {
                    console.log('error', err);
                })
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', 'fetchStream', '$stateParams', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;





/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hybrid_alerts/nta_details.ts
 **/